import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { http, messageError } from "./base";

export function fetchSelf() {
  return http.get("/users/self/").pipe(
    map(({ data }: any) => {
      return data;
    }),
    catchError(() => throwError("Unable to get self."))
  );
}

export function login(email: string, password: string, token: string) {
  return http.post("/token/", { email, password, token }).pipe(
    map(({ data }) => {
      return data;
    }),
    catchError((error) => messageError(error, "Unable to log in."))
  );
}

export function createUser(
  email: string,
  password: string,
  firstName: string,
  lastName: string,
  token: string
) {
  return http
    .post("/users/", { email, password, firstName, lastName, token })
    .pipe(
      map(({ data }) => {
        return data;
      }),
      catchError((error) =>
        messageError(error, "Error occurred when signing up. Please try again.")
      )
    );
}

export function deleteUser(confirm: string) {
  return http.post("/users/delete", { confirm }).pipe(
    map(({ data }) => {
      return data;
    }),
    catchError((error) =>
      messageError(
        error,
        "Error occurred when deleting account. Please contact support."
      )
    )
  );
}

export function forgotPassword(email: string, token: string) {
  return http.post("/users/forgot-password", { email, token }).pipe(
    map(({ data }) => {
      return data;
    }),
    catchError((error) =>
      messageError(
        error,
        "Error occurred when resetting password. Please contact support."
      )
    )
  );
}

export function resetPassword(code: string, password: string) {
  return http.post("/users/reset-password", { code, password }).pipe(
    map(({ data }) => {
      return data;
    }),
    catchError((error) =>
      messageError(
        error,
        "Error occurred when resetting password. Please contact support."
      )
    )
  );
}
